exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-3cc6d9c0] {\n  max-width: 600px;\n}\n", ""]);

// exports
